import { IChuongTrinhDaoTaoRangBuocAddMultipleSysRequest } from "../../../model/request/ctdt/IChuongTrinhDaoTaoRangBuocAddMultipleSysRequest";
import { IChuongTrinhDaoTaoRangBuoc } from "../../../model/respone/ctdt/IChuongTrinhDaoTaoRangBuoc";
import { IChuongTrinhDaoTaoRangBuocViewModel } from "../../../model/respone/ctdt/IChuongTrinhDaoTaoRangBuocViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export interface IChuongTrinhDaoTaoRangBuocActionTypeBase<T> {
    id_dt: number,
    data: T
}
export const eChuongTrinhDaoTaoRangBuocActionsObj = {
    SAVE_MULTIPLE_START: {} as IChuongTrinhDaoTaoRangBuocActionTypeBase<IChuongTrinhDaoTaoRangBuocAddMultipleSysRequest>,
    SAVE_MULTIPLE_SUCCESS: undefined,
    SAVE_MULTIPLE_ERROR: "",

    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IChuongTrinhDaoTaoRangBuocViewModel[],
    LOAD_ERROR: "",
};


export const eChuongTrinhDaoTaoRangBuocActionIds = generateActionTypeIds(eChuongTrinhDaoTaoRangBuocActionsObj, "CHUONG_TRINH_DAO_TAO_RANG_BUOC");
export type IChuongTrinhDaoTaoRangBuocActionTypes = IGenericActionType<typeof eChuongTrinhDaoTaoRangBuocActionsObj, "CHUONG_TRINH_DAO_TAO_RANG_BUOC">;